// react
import React, { Component, PropTypes } from "react"
import { connect } from "react-redux"
//material-ui
import MenuItem from "material-ui/MenuItem"
import MUISelectField from "material-ui/SelectField"
// app
import { list } from "actions/ref/actions.js"


export const Style = {
    TextOnly: 0,
    TextAndCode: 1,
    CodeAndText: 2
}

class SelectField extends Component {
    constructor(props) {
        super()

        this.state = {
            errorText: "",
            value: props.value
        }

        if (!props.value && props.mandatory)
            if (props.onError) props.onError(true)

        this.onChange = (e, key, value) => {
            if (this.props.mandatory && value === "") {
                this.setState({ errorText: "This field is required" })
                if (this.props.onError) this.props.onError(true)
                return false
            }
            
            this.setState({ errorText: "", value })

            if (this.props.onError) this.props.onError(false)
            if (this.props.onChange) this.props.onChange(value, key)
        }
    }

    componentDidMount() {
        if (!this.props.reference) this.props.list()
    }

    getMenuItem(item, key) {
        switch (this.props.style) {
            case Style.CodeAndText:
                return <MenuItem
                    value={ item }
                    key={ key }
                    primaryText={ <div>{item.code} <small>({item.text})</small></div> } />
            case Style.TextAndCode:
                return <MenuItem
                    value={ item }
                    key={ key }
                    primaryText={ <div>{item.text} <small>({item.code})</small></div> } />
            default:
                return <MenuItem
                    value={ item.text }
                    key={ key }
                    primaryText={ item.text } />
        }
    }

    render() {
        const label = this.props.label + ((this.props.mandatory) ? ("*") : (""))
        const children = []

        if (this.props.reference)
            if (this.props.reference.has("data"))
                this.props.reference.get("data").forEach(item => {
                    children.push(this.getMenuItem(item, children.length))
                })
        
        return (
            <MUISelectField
                value={ this.state.value }
                floatingLabelText={ label }
                hintText="Please select"
                errorText={ this.state.errorText }
                onChange={ this.onChange }
                fullWidth={ true }
            >
                { children }
            </MUISelectField>
        )
    }
}

SelectField.propTypes = {
    label: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
    mandatory: PropTypes.bool,
    maxLength: PropTypes.number,
    style: PropTypes.number,
    value: PropTypes.any,
    onChange: PropTypes.func,
    onError: PropTypes.func
}

const mapStateToProps = (state, ownProps) => {
    return {
        reference: state.ref.get(ownProps.table)
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        list: () => dispatch(list(ownProps.table))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectField)


/** WEBPACK FOOTER **
 ** ./src/containers/SelectField/selectfield.js
 **/